import React, { useState, useEffect, useContext } from "react";
import InputStyles from "../InputStyles";
// import PropTypes from "prop-types";
import {
  getFormattedDate,
  generateRandomString,
  formatDate,
  getAgeFromBirthday,
} from "../../../utils/helpers";
import BirthdateInputStyles from "./BirthdateInputStyles";
import AppContext from "../../../App/AppContext";

const BirthdateInput = ({
  label = "Date of Birth",
  register,
  formState: { errors = {} } = {},
  fieldName = "dob_patient",
  required = false,
  errorMessage,
  clearErrors,
  setError,
  setValue,
  helperText = "MM/DD/YYYY",
}) => {
  // allow ages 18-100 by default, can be overwritten with the min & max props

  const { options: { age_min = 18, age_max = 65 } = {} } =
    useContext(AppContext);

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const inputRandomId = isClient
    ? `${fieldName}-${generateRandomString()}`
    : null;

  return (
    <InputStyles className="birthdate-input">
      <div className="label-container">
        <div>
          <label
            htmlFor={inputRandomId}
            dangerouslySetInnerHTML={{ __html: label }}
          />
          {required && <span className="required-asterisk">*</span>}
        </div>
        {helperText && <span className="helper-text">{helperText}</span>}
      </div>
      <input
        type="text"
        role="textbox"
        id={inputRandomId}
        name={fieldName}
        maxLength={10}
        className={`${errors[fieldName] ? "error" : ""}`}
        placeholder=" __ / __ / ____"
        {...register(fieldName, {
          required,
          validate: (value) => {
            const dateValue = new Date(value);
            const isValidDate =
              value.length === 10 &&
              dateValue != "Invalid Date" &&
              dateValue < new Date();

            const age = getAgeFromBirthday(value);
            // clear error if field is not required and value is empty
            if (!value && !required) return true;
            if (isValidDate && age < age_min) {
              return `Patients must be at least ${age_min} years old.`;
            } else if (isValidDate && age < 100 && age > age_max) {
              return `Currently serving patients between ${age_min} - ${age_max}`;
            } else if (!isValidDate) {
              return "Date of Birth is not valid.";
            }
            return true;
          },
        })}
        onKeyUp={(e) => {
          setValue(fieldName, formatDate(e.target.value));
        }}
      />
      {errors[fieldName] && (
        <span className="input-error">
          {errors[fieldName]?.message || errorMessage}
        </span>
      )}
    </InputStyles>
  );
};
export default BirthdateInput;

// BirthdateInput.propTypes = {
//   register: PropTypes.func.isRequired,
//   fieldName: PropTypes.string,
//   label: PropTypes.string,
//   required: PropTypes.bool,
//   formState: PropTypes.object,
//   errorMessage: PropTypes.string,
//   setError: PropTypes.func.isRequired,
//   helperText: PropTypes.string,
// };
